module.exports = "https://coursera_assets.s3.amazonaws.com/images/f811afd90b6970f7146cc446781caf6a.svg";